export default "__VITE_ASSET__CW6$OWbW__"